import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LanguageEntity} from './language.entity';

@EntityTable('language_term', 'cf4bd509-88cc-499a-b27c-9d7523ea5279')
export class LanguageTermEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LanguageEntity, false, false, FieldRelationKind.BELONGS_TO, 'language', 'aliasId', 'languageId')
    public languageId: string;

    @Column(FieldTypeKind.STRING)
    public targetId: string;

    @Column(FieldTypeKind.ANY)
    public targetIds: string[];

    @Column(FieldTypeKind.STRING)
    public text: string;

    @Column(FieldTypeKind.STRING)
    public pluralText: string;

    @Column(FieldTypeKind.ANY)
    public others: any;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;
}
